<template>
  <div class="mt-3 d-flex justify-content-center" v-if="postDataLength > perPage * nowPage">
    <a href="#" class="btn btn-lg btn-outline-primary w-75"
      @click.prevent="morePage">{{ btnText }}</a>
  </div>
</template>

<script>
export default {
  props: {
    postDataLength: Number,
    btnText: String,
  },
  data() {
    return {
      perPage: 10,
      nowPage: 1,
    };
  },
  methods: {
    morePage() {
      this.nowPage += 1;
      this.$emit('more-page', this.nowPage);
    },
  },
  watch: {
    perPage() {
      this.$emit('per-page', this.perPage);
    },
  },
  mounted() {
    this.$emit('per-page', this.perPage);
  },
};
</script>
